import { render, staticRenderFns } from "./messageTemplateEdit.vue?vue&type=template&id=025fdbac"
import script from "./messageTemplateEdit.vue?vue&type=script&lang=js"
export * from "./messageTemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports